import TrumpProfit from './trumpProfit.png';
import VvvProfit from './vvvProfit.png';
import SuiProfit from './suiProfit.png';
import RayProfit from './rayProfit.png';

const ProfitExamples5 = () => {
  return (
    <div
      style={{
        flex: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <p style={{ fontSize: 24, fontWeight: 'bold' }}>
        New Coins Historical Profit
      </p>
      <div
        style={{
          display: 'grid',
          gridTemplateRows: 'repeat(2, 1fr)',
          gridTemplateColumns: 'repeat(2, 1fr)',
          height: '100%',
          width: '100%',
        }}
      >
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={TrumpProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={VvvProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={SuiProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={RayProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
      </div>
    </div>
  );
};

export default ProfitExamples5;
